/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import DeselectIcon from "components/icons/common/DeselectIcon";
import SelectIcon from "components/icons/common/SelectIcon";

import ImageViewer, { ImageViewerInterface } from "../ImageViewer/ImageViewer";
import Stack from "../Stack";
import Text from "../Text";

interface ICard {
  media: ImageViewerInterface;
  title: string;
  className?: string;
  disabled?: boolean;
  isSelected?: boolean;
  isLoading?: boolean;
  onClick: () => void;
  note?: string | React.ReactNode;
  as?: "div" | "li";
  multiple?: boolean;
  selectedId?: number;
  id?: number;
  dropDownSelect?: boolean;
}

const SelectCard = ({
  media = {
    src: "",
    size: "lg",
    variant: "circle",
    fit: "cover",
  },
  title,
  isSelected,
  onClick,
  disabled,
  className,
  note,

  as = "li",
}: ICard) => {
  const Tag = as as any;
  return (
    <Tag
      onClick={() => !disabled && onClick()}
      role="button"
      className={cn("w-full select-none", {
        "cursor-not-allowed": disabled,
      })}
      test-id="gdiRmA04"
    >
      <div
        className={cn("flex items-center w-full h-14 text-white", className)}
        test-id="ufgh3Wvh"
      >
        {media.src && (
          <div
            className={cn(
              "h-auto w-auto",
              media.size === "lg" ? "pr-3" : "pr-1.5",
            )}
            test-id="E5VLG_wG"
          >
            <ImageViewer
              src={media.src}
              placeholderSize="sm"
              alt={title}
              className={media.size === "lg" ? "h-11 w-11" : "w-6 h-6"}
              variant={media.variant ? media.variant : undefined}
              fit={media.fit}
              test-id="ttGFlo22"
            />
          </div>
        )}

        <div
          className="flex items-center justify-between relative w-full space-x-s10"
          test-id="Gdk0eNwG"
        >
          <Stack className="text-left capitalize" test-id="gdWC2FQG">
            <Text className="line-clamp-2" test-id="cSOkeomi">
              {title}
            </Text>
          </Stack>

          <div className="flex items-center space-x-s10" test-id="T6EKD3HZ">
            {!!note && note}
            {isSelected && (
              <div test-id="LKg_-qFj">
                {<DeselectIcon test-id="ZE5xT42r" />}
              </div>
            )}
            {!isSelected && (
              <div className="pr-0.5 pointer-events-none" test-id="R-dnDNrY">
                {<SelectIcon test-id="rEt_J5Zu" />}
              </div>
            )}
          </div>
        </div>
      </div>
    </Tag>
  );
};

export default SelectCard;
